import React, { Component } from 'react';

const styles = {
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }
};

export default class _PrimaryButton extends Component {

  constructor(props) {
    super(props);
    this.state = {
      hover: false
    };
  }
  
  render() {
    const { title, image, onPress, disabled } = this.props;
    
    return (
      <div style={{ ...styles.container, ...this.backgroundStyle(), ...this.props.style }}
           onMouseEnter={this.toggleHover}
           onMouseLeave={this.toggleHover}
           onClick={!disabled && onPress}>
        {title && <p>{title}</p>}
        {this.props.children}
      </div>
    );
  }

  toggleHover = () => {
    this.setState({ hover: !this.state.hover });
  };
  
  backgroundStyle = () => {
    const disabled = this.props.disabled;
    if ( disabled ) {
      return { backgroundColor: '#EEEEEE' };
    }
    return this.state.hover
      ? { backgroundColor: '#A4DA11' }
      : { backgroundColor: '#C0FF14'};
  };
}



// WEBPACK FOOTER //
// ./src/base-components/_primary-button.js